export const isValidUrl = (url) => {
	let isValid;
	try {
		isValid = new URL(url);
	} catch (e) {
		return false;
	}
	return isValid.protocol;
};
